import { StateSchema } from 'app/providers/StoreProvider';

export const getOrderVersionPreference = (state: StateSchema) =>
    state.orderVersionPreference.preference;
